import React, { useState, useEffect } from 'react';
import { 
  Button, 
  MenuItem, 
  Select, 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow, 
  FormControl, 
  InputLabel,
  Paper,
  Typography,
  Box
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'; 

// Constantes para datos compartidos
const API_CONFIG = {
  token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
  ambiente: "DESA",
  dispositivo: {
    Marca: "SAMSUNG",
    Modelo: "S22002B",
    Version: "Android 18.125",
    McAdress: null,
    PowerStatus: "84%",
    WifiStatus: "Conected to iphone de Mauricio",
    GPSStatus: "ON",
    GPS: "321|-485|321"
  },
  usuario: {
    Codigo: "",
    UserNickName: "pierril"
  }
};

const HeladosPage = () => {
  // Estados para el formulario 
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth); 
  const [tienda, setTienda] = useState('');
  const [maquina, setMaquina] = useState('');
  const [tolbas, setTolbas] = useState({
    1: { sabor: '', codigo: '' },
    2: { sabor: '', codigo: '' }
  });
  const [historial, setHistorial] = useState([]);
  const [tiendas, setTiendas] = useState([]);
  const [maquinas, setMaquinas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [saboresDisponibles, setSaboresDisponibles] = useState([]);
  const [tiendaSeleccionada, setTiendaSeleccionada] = useState(null);
  const [maquinaSeleccionada, setMaquinaSeleccionada] = useState(null);
  
  // Estados para los datos del API
  const [heladosAgrupados, setHeladosAgrupados] = useState([]);
  const [cargandoHelados, setCargandoHelados] = useState(false);

  // Función para agrupar sabores por máquina
  const agruparSaboresPorMaquina = (datosApi) => {
    console.log(datosApi)
    const agrupadoPorMaquina = datosApi.reduce((resultado, item) => {
      const clave = `${item.CodigoMaquina}-${item.Maquina}`;
      
      if (!resultado[clave]) {
        resultado[clave] = {
          Tienda: item.Tienda,
          CodigoTienda: item.CodigoTienda,
          Maquina: item.Maquina,
          CodigoMaquina: item.CodigoMaquina,
          Warehouse: item.Warehouse,
          Tolvas: []
        };
      }
      
      resultado[clave].Tolvas.push({
        Nombre: item.Tolva,
        CodigoTolva: item.CodigoTolva,
        Sabor: item.NombreHelado.trim(),
        CodigoSabor: item.CodigoHelado,
        CodigoPT: item.CodigoPT,
        Fecha: item.Fecha
      });
      
      return resultado;
    }, {});
    
    return Object.values(agrupadoPorMaquina).map(maquina => {
      const tolvasOrdenadas = [...maquina.Tolvas].sort((a, b) => a.CodigoTolva - b.CodigoTolva);
      
      return {
        ...maquina,
        Sabor1: tolvasOrdenadas[0]?.Sabor || 'No asignado',
        Sabor2: tolvasOrdenadas[1]?.Sabor || 'No asignado',
        Mix: `${tolvasOrdenadas[0]?.Sabor || ''}-${tolvasOrdenadas[1]?.Sabor || ''}`.replace(/-$/, ''),
        Fecha: tolvasOrdenadas[0]?.Fecha
      };
    });
  };

  // Obtener datos de helados existentes
  const obtenerHeladosExistentes = async () => {
    try {
      setCargandoHelados(true);
      const datos = {
        ...API_CONFIG,
        DatosMetodo: {
          NombreMetodo: "ListaCRUDHelados",
          Datos_Recibidos: JSON.stringify({
            TipoOperacion: "SelectForViewHDT"
          })
        }
      };
  
      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;
      console.log(url);
      const response = await fetch(url);
      const data = await response.json();
      const datosParseados = JSON.parse(data.datos_Generados);
      console.log(datosParseados.RESP);
      
      if (datosParseados && Array.isArray(datosParseados.RESP)) {
        // Primero agrupamos los sabores por máquina
        let agrupados = agruparSaboresPorMaquina(datosParseados.RESP);
        
        // Luego filtramos por warehouse si el usuario coincide
        if (user.usuario) {
          const heladosFiltrados = agrupados.filter(
            helado => helado.Warehouse === user.usuario
          );
          
          // Si hay coincidencias, usamos los filtrados; si no, todos los helados
          agrupados = heladosFiltrados.length > 0 ? heladosFiltrados : agrupados;
        }
        
        setHeladosAgrupados(agrupados);
      }
    } catch (error) {
      console.error("Error al obtener helados existentes:", error);
    } finally {
      setCargandoHelados(false);
    }
  };

  // Helpers
  const obtenerCodigoSabor = (sabor) => {
    const saborEncontrado = saboresDisponibles.find(item => item.SaborHelado === sabor);
    return saborEncontrado ? saborEncontrado.ItemCode : '';
  };

  // Handlers (se mantienen igual que antes)
  const manejarCambioTienda = (e) => {
    const nombreTienda = e.target.value;
    const tienda = tiendas.find(t => t.tie_nombre === nombreTienda);
    setTienda(nombreTienda);
    setTiendaSeleccionada(tienda);
    resetearSelecciones();
  };

  const manejarCambioMaquina = (e) => {
    const codigoMaquina = e.target.value;
    const maquina = maquinas.find(m => m.CodigoMaquina == codigoMaquina);
    setMaquina(codigoMaquina);
    setMaquinaSeleccionada(maquina);
    
    if (maquina) {
      setTolbas({
        1: { sabor: '', codigo: maquina.tolvas[0]?.codigo || '' },
        2: { sabor: '', codigo: maquina.tolvas[1]?.codigo || '' }
      });
    } else {
      setTolbas({
        1: { sabor: '', codigo: '' },
        2: { sabor: '', codigo: '' }
      });
    }
  };

  const manejarCambioTolva = (numeroTolva) => (e) => {
    const sabor = e.target.value;
    
    setTolbas(prev => ({
      ...prev,
      [numeroTolva]: {
        ...prev[numeroTolva],
        sabor: sabor
      }
    }));
  };

  const manejarGuardar = async () => {
    setIsLoading(true);
    
    try {
      if (tolbas[1].sabor) {
        const codigoSabor = obtenerCodigoSabor(tolbas[1].sabor);
        await enviarDatosTolva(tolbas[1].sabor, codigoSabor, tolbas[1].codigo);
      }
      
      if (tolbas[2].sabor) {
        const codigoSabor = obtenerCodigoSabor(tolbas[2].sabor);
        await enviarDatosTolva(tolbas[2].sabor, codigoSabor, tolbas[2].codigo);
      }
      
      const nuevaEntrada = {
        fecha: new Date().toLocaleDateString(),
        tienda,
        tolba1: tolbas[1].sabor,
        tolba2: tolbas[2].sabor,
        mix: `${tolbas[1].sabor}-${tolbas[2].sabor}`
      };
      setHistorial([...historial, nuevaEntrada]);
      
      setTolbas({
        1: { ...tolbas[1], sabor: '' },
        2: { ...tolbas[2], sabor: '' }
      });
      
      // Actualizar lista de helados existentes después de guardar
      await obtenerHeladosExistentes();
    } catch (error) {
      console.error('Error al guardar:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Resto de funciones (se mantienen igual que antes)
  const resetearSelecciones = () => {
    setTolbas({
      1: { sabor: '', codigo: '' },
      2: { sabor: '', codigo: '' }
    });
    setMaquina('');
    setMaquinaSeleccionada(null);
  };

  const construirDatosAPI = (metodo, datosAdicionales = {}) => {
    return {
      ...API_CONFIG,
      DatosMetodo: {
        NombreMetodo: metodo,
        Datos_Recibidos: typeof datosAdicionales === 'string' 
          ? datosAdicionales 
          : JSON.stringify(datosAdicionales)
      }
    };
  };

  const hacerPeticionAPI = async (metodo, datosAdicionales) => {
    const datos = construirDatosAPI(metodo, datosAdicionales);
    const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;
    
    try {
      const response = await fetch(url);
      const data = await response.json();
      return JSON.parse(data.datos_Generados);
    } catch (error) {
      console.error('Error en la petición:', error);
      throw error;
    }
  };

  const obtenerTiendas = async () => {
    const datos = {
      Tabla: "gn.tie_tienda",
      TipoOperacion: "Select"
    };
    const respuesta = await hacerPeticionAPI("ListaCRUDHelados", datos);
    if (respuesta) {
      console.log("Usuario actual:", user.usuario); // ✔️ Mantenemos el log del usuario
      
      // 1. Filtramos tiendas donde el warehouse coincida con el usuario
      const tiendasFiltradas = respuesta.RESP.filter(
        tienda => tienda.tie_cod_warehouse === user.usuario
      );
  
      // 2. Si hay match, usamos las filtradas; si no, todas las tiendas
      setTiendas(tiendasFiltradas.length > 0 ? tiendasFiltradas : respuesta.RESP);
    }
  };

  const obtenerSaboresDelDia = async () => {
    if (!tiendaSeleccionada) return;
    const datos = `{"BODEGA":"${tiendaSeleccionada.tie_cod_warehouse}"}`;
    const respuesta = await hacerPeticionAPI("ListaSaboresDelDia", datos);
    if (respuesta) setSaboresDisponibles(respuesta.SABORESHELADOS);
  };

  const obtenerMaquinasYTolvas = async () => {
    if (!tiendaSeleccionada) return;
    const respuesta = await hacerPeticionAPI("ListaCRUDHelados", {
      TipoOperacion: "SelectForViewTMTGN"
    });
    
    if (respuesta) {
      const datosFiltrados = respuesta.RESP.filter(item => 
        item.Warehouse === tiendaSeleccionada.tie_cod_warehouse
      );
      
      const maquinasAgrupadas = datosFiltrados.reduce((acc, item) => {
        const maquinaExistente = acc.find(m => m.CodigoMaquina === item.CodigoMaquina);
        
        if (maquinaExistente) {
          maquinaExistente.tolvas.push({
            nombre: item.Tolva,
            codigo: item.CodigoTolva
          });
        } else {
          acc.push({
            Maquina: item.Maquina,
            CodigoMaquina: item.CodigoMaquina,
            tolvas: [{
              nombre: item.Tolva,
              codigo: item.CodigoTolva
            }]
          });
        }
        return acc;
      }, []);
      
      setMaquinas(maquinasAgrupadas);
      
      if (maquinasAgrupadas.length > 0) {
        setMaquina(maquinasAgrupadas[0].CodigoMaquina);
        setMaquinaSeleccionada(maquinasAgrupadas[0]);
        setTolbas({
          1: { sabor: '', codigo: maquinasAgrupadas[0].tolvas[0]?.codigo || '' },
          2: { sabor: '', codigo: maquinasAgrupadas[0].tolvas[1]?.codigo || '' }
        });
      }
    }
  };

  const enviarDatosTolva = async (sabor, codigoSabor, codigoTolva) => {
    if (!codigoTolva) {
      console.error('Código de tolva no definido');
      throw new Error('Código de tolva no definido');
    }
    
    const datos = {
      Tabla: "hdd.hl_helados",
      TipoOperacion: "Insert",
      hl_nombre: sabor,
      hl_ptpr: codigoSabor,
      hl_estado: 1,
      hl_codus_crea: 101,
      hl_codus_mod: 101,
      th_codtol: codigoTolva,
      hl_fecha: new Date().toISOString(),
    };
    
    await hacerPeticionAPI("ListaCRUDHelados", datos);
  };

  // Efectos
  useEffect(() => {
    const cargarDatosIniciales = async () => {
      await obtenerTiendas();
      await obtenerHeladosExistentes(); 
      console.log(user.usuario)
    };
    cargarDatosIniciales();
  }, []);

  useEffect(() => {
    if (tiendaSeleccionada) {
      obtenerSaboresDelDia();
      obtenerMaquinasYTolvas();
    }
  }, [tiendaSeleccionada]);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Creación de Helados</h1>

      {/* Formulario de creación */}
      <Paper elevation={3} style={{ padding: '20px', marginBottom: '30px' }}>
        <Typography variant="h6" gutterBottom>Nueva Combinación</Typography>
        
        <FormControl variant="outlined" fullWidth style={{ marginBottom: '20px' }}>
          <InputLabel id="tienda-label">Seleccionar Tienda</InputLabel>
          <Select
            labelId="tienda-label"
            value={tienda}
            onChange={manejarCambioTienda}
            label="Seleccionar Tienda"
          >
            <MenuItem value=""><em>Ninguna</em></MenuItem>
            {tiendas.map((item, index) => (
              <MenuItem key={index} value={item.tie_nombre}>
                {item.tie_nombre} ({item.tie_cod_warehouse})
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {tiendaSeleccionada && (
          <FormControl variant="outlined" fullWidth style={{ marginBottom: '20px' }}>
            <InputLabel id="maquina-label">Seleccionar Máquina</InputLabel>
            <Select
              labelId="maquina-label"
              value={maquina}
              onChange={manejarCambioMaquina}
              label="Seleccionar Máquina"
            >
              <MenuItem value=""><em>Ninguna</em></MenuItem>
              {maquinas.map((item, index) => (
                <MenuItem key={index} value={item.CodigoMaquina}>
                  {item.Maquina} ({item.tolvas.length} tolvas)
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {maquinaSeleccionada?.tolvas.map((tolva, index) => {
          const numeroTolva = index + 1;
          return (
            <FormControl key={tolva.codigo} variant="outlined" fullWidth style={{ marginBottom: '20px' }}>
              <InputLabel id={`tolva-${tolva.codigo}-label`}>{tolva.nombre} (Código: {tolva.codigo})</InputLabel>
              <Select
                labelId={`tolva-${tolva.codigo}-label`}
                value={tolbas[numeroTolva]?.sabor || ''}
                onChange={manejarCambioTolva(numeroTolva)}
                label={`${tolva.nombre} (Código: ${tolva.codigo})`}
              >
                <MenuItem value=""><em>Ninguna</em></MenuItem>
                {saboresDisponibles.map((item, idx) => (
                  <MenuItem key={idx} value={item.SaborHelado}>
                    {item.SaborHelado}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        })}

        <Button 
          variant="contained" 
          onClick={manejarGuardar} 
          fullWidth 
          disabled={isLoading || !tolbas[1].sabor || !tolbas[2].sabor}
        >
          {isLoading ? 'Guardando...' : 'Guardar'}
        </Button>
      </Paper>

      {/* Historial local */}
      {historial.length > 0 && (
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '30px' }}>
          <Typography variant="h6" gutterBottom>Historial Reciente</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Fecha</TableCell>
                <TableCell>Tienda</TableCell>
                <TableCell>Helado 1</TableCell>
                <TableCell>Helado 2</TableCell>
                <TableCell>Mix</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historial.map((fila, index) => (
                <TableRow key={index}>
                  <TableCell>{fila.fecha}</TableCell>
                  <TableCell>{fila.tienda}</TableCell>
                  <TableCell>{fila.tolba1}</TableCell>
                  <TableCell>{fila.tolba2}</TableCell>
                  <TableCell>{fila.mix}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      {/* Helados existentes del API */}
      <Paper elevation={3} style={{ padding: '20px' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">Helados Existentes</Typography>
          <Button 
            variant="outlined" 
            onClick={obtenerHeladosExistentes}
            disabled={cargandoHelados}
          >
            {cargandoHelados ? 'Actualizando...' : 'Actualizar'}
          </Button>
        </Box>
        
        {heladosAgrupados.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Tienda</TableCell>
                <TableCell>Máquina</TableCell>
                <TableCell>Sabor 1</TableCell>
                <TableCell>Sabor 2</TableCell>
                <TableCell>Mix</TableCell>
                <TableCell>Fecha</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {heladosAgrupados.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.Tienda}</TableCell>
                  <TableCell>{item.Maquina}</TableCell>
                  <TableCell>{item.Sabor1}</TableCell>
                  <TableCell>{item.Sabor2}</TableCell>
                  <TableCell>{item.Mix}</TableCell>
                  <TableCell>{item.Fecha}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography variant="body1" style={{ textAlign: 'center', padding: '20px' }}>
            {cargandoHelados ? 'Cargando helados existentes...' : 'No hay helados registrados'}
          </Typography>
        )}
      </Paper>
    </div>
  );
};

export default HeladosPage;